import { type ApiKeyAuthClient } from '@automation-suite/shared-clients-api-key-auth';

class EIPApiKeyAuthClient implements ApiKeyAuthClient {
  public async getApiKey(): Promise<string> {
    const apiKey = process.env.NX_PUBLIC_EIP_API_KEY;

    if (!apiKey) {
      throw new Error('No API key found in process.env.NX_PUBLIC_EIP_API_KEY');
    }

    return apiKey;
  }
}

export const eipApiKeyAuthClient: ApiKeyAuthClient = new EIPApiKeyAuthClient();
